module.exports = __webpack_public_path__ + "img/sprinkle-23.df3e2586.jpg";